'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var v=({label:a,icon:s,iconBackground:l,removeContentBorder:i,useIconBorder:c,narrow:m,className:n,...d})=>{let p=n||"",b=i?"remove-content-border":"",g=c?"use-icon-border":"",e=m?"narrow":"";return jsxRuntime.jsxs("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-item-box ${e} ${p}`),...d,children:[jsxRuntime.jsx("div",{className:chunkWAUX3N2G_js.a(`icon-wrapper ${e} ${g}`),style:{backgroundColor:l},children:s&&jsxRuntime.jsx("img",{src:s,alt:""})}),jsxRuntime.jsx("div",{className:chunkWAUX3N2G_js.a(`label-wrapper ${b} ${e}`),children:jsxRuntime.jsx("span",{className:"label-text",children:a})})]})},B=v;

exports.a = B;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-BH3YCWVL.js.map